var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastodon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 11.6147V8.2582M12.0002 8.2582C12.0002 7.56516 11.7249 6.9005 11.2348 6.41044C10.7448 5.92038 10.0801 5.64507 9.38707 5.64507C8.69402 5.64507 8.02936 5.92038 7.5393 6.41044C7.04925 6.9005 6.77393 7.56516 6.77393 8.2582V13.6742M12.0002 8.2582C12.0002 7.56516 12.2755 6.9005 12.7656 6.41044C13.2556 5.92038 13.9203 5.64507 14.6133 5.64507C14.9565 5.645 15.2964 5.71254 15.6135 5.84383C15.9306 5.97511 16.2187 6.16758 16.4615 6.41024C16.7042 6.6529 16.8967 6.941 17.0281 7.25807C17.1594 7.57515 17.227 7.915 17.227 8.2582V13.6742M21.5824 9.98026C21.5824 13.4934 21.0367 14.695 19.9631 15.7018C17.7879 17.7422 12.0002 17.5827 12.0002 17.5827C10.6813 17.5989 9.36357 17.4997 8.06197 17.2863C8.06197 17.2863 7.42975 21.4491 15.4196 19.4075L15.3388 21.7882C14.1209 21.951 2.53307 26.2351 2.44885 11.3132L2.41797 9.97914C2.41797 6.46539 2.44604 5.21666 4.03728 3.45979C6.03896 1.2498 12.0002 1.53166 12.0002 1.53166C12.0002 1.53166 17.9614 1.2498 19.9631 3.46035C21.5544 5.21722 21.5824 6.46708 21.5824 9.98026Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastodon);
export default __webpack_public_path__ + "static/media/mastodon.5090aba64507e54f2399a9d24790ff17.svg";
export { ForwardRef as ReactComponent };